import PropTypes from 'prop-types';

import { Button, ModalV2 as Modal } from '@utilities';

const ConfirmRemoveTopicModal = ({ isActive, isConfirmDisabled, onCancel, onConfirm }) => (
  <Modal
    buttons={[
      <Button key="cancel-remove-topic" onClick={onCancel} text="Cancel" variant="secondary" />,
      <Button
        isDisabled={isConfirmDisabled}
        key="confirm-remove-topic"
        onClick={onConfirm}
        text="Remove"
        variant="error"
      />,
    ]}
    isActive={isActive}
    onClose={onCancel}
    size="small"
    title="Remove"
  >
    <p>Are you sure you would like to remove this topic card? You&apos;ll lose its results.</p>
  </Modal>
);

ConfirmRemoveTopicModal.propTypes = {
  isActive: PropTypes.bool,
  isConfirmDisabled: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmRemoveTopicModal;
